import * as React from 'react';
import * as classNames from 'classnames';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { padStart as _padStart } from 'lodash';
import { PortalSearchBarField } from '../layout';
import { SavingIndicator, SavingIndicatorStatus } from '../indicator';
import { Button, EButtonType } from '../action';

// Styles
const s = require('./SearchForm.css');
const searchIcon = require('./../../assets/search-icon.svg');
const openArrow = require('./../../assets/open-arrow.svg');
const checkmarkIcon = require('./../../assets/checkmark-green-icon.svg');

// Types
type value = string | number | null;

// Interfaces
export interface ISearchFormResult {
    key?: string;
    value: value;
    label?: string;
}

// Props
interface ISearchFormProps {
    onSearchValueChange: (value: string) => void;
    onResultSelected: (value: value) => void;
    searchFieldClassName?: string;
    searchValue: string;
    searchLabel?: string;
    loadingResults?: boolean;
    results: ISearchFormResult[];
    resultSelected: value;
    resultsLabel?: string;
    resultsLoadingLabel?: string;
    noResultsLabel?: string;
}

// Component
@observer
export class SearchForm extends React.Component<ISearchFormProps, {}> {
    static get defaultProps(): ISearchFormProps {
        return {
            onSearchValueChange: null,
            onResultSelected: null,
            searchFieldClassName: null,
            searchValue: '',
            searchLabel: 'Search',
            loadingResults: false,
            results: [],
            resultSelected: null,
            resultsLabel: 'Results',
            resultsLoadingLabel: 'Loading',
            noResultsLabel: 'No results'
        };
    }

    @computed
    private get totalResults(): number {
        return this.props.results.length;
    }

    render() {
        return (
            <div>
                <div className={s.header}>
                    <PortalSearchBarField
                        autoFocus={true}
                        className={classNames(s.searchField, this.props.searchFieldClassName)}
                        value={this.props.searchValue}
                        label={this.props.searchLabel}
                        field="search"
                        lightness={0}
                        icon={searchIcon}
                        onChange={this.handleSearchValueChange}
                    />
                </div>

                <div className={s.results}>
                    <h3>{this.props.resultsLabel}</h3>

                    {this.props.searchValue.trim().length > 0 &&
                        this.props.onSearchValueChange && (
                            <Button
                                className={s.clearSearchButton}
                                inBox={true}
                                type={EButtonType.BorderOnly}
                                onClick={this.handleClearingSearchResults}
                            >
                                Clear search
                            </Button>
                        )}

                    <SavingIndicator
                        className={s.loading}
                        loadingSpinnerOnRight={true}
                        labels={{ saving: this.props.resultsLoadingLabel }}
                        status={this.props.loadingResults ? SavingIndicatorStatus.Saving : SavingIndicatorStatus.None}
                    />

                    {(this.totalResults > 0 && (
                        <ul className={s.list}>
                            {this.props.results.map((result, resultIndex) => {
                                const selected = result.value === this.props.resultSelected;

                                return (
                                    <li
                                        key={typeof result.key !== 'undefined' && result.key ? result.key : result.value}
                                        className={classNames(s.result, { [s.active]: selected })}
                                    >
                                        <button onClick={this.handleResultSelected(result.value)}>
                                            <strong>
                                                {typeof result.label !== 'undefined' && result.label
                                                    ? result.label
                                                    : result.value}
                                            </strong>
                                            <img
                                                src={selected ? checkmarkIcon : openArrow}
                                                width={selected ? 15 : 9}
                                                height={selected ? 19 : 13}
                                                alt=""
                                            />
                                        </button>
                                        <span>
                                            {this.totalResults > 999
                                                ? _padStart((resultIndex + 1).toString(), 4, '0')
                                                : this.totalResults > 99
                                                  ? _padStart((resultIndex + 1).toString(), 3, '0')
                                                  : this.totalResults > 9
                                                    ? _padStart((resultIndex + 1).toString(), 2, '0')
                                                    : resultIndex + 1}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    )) ||
                        (this.props.loadingResults === false && <p className={s.noResults}>{this.props.noResultsLabel}</p>)}
                </div>
            </div>
        );
    }

    private handleClearingSearchResults = () => {
        if (this.props.onSearchValueChange) {
            this.props.onSearchValueChange('');
        }
    };

    private handleSearchValueChange = (field: string, value: string) => {
        if (this.props.onSearchValueChange) {
            this.props.onSearchValueChange(value);
        }
    };

    private handleResultSelected = (value: value) => (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onResultSelected) {
            this.props.onResultSelected(value);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/forms/SearchForm.tsx